"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'insights',
    userFriendlyName: 'Insights',
    dark: false,
    colors: {
        primary: '#fff',
        primaryText: '#000',
        primaryDark: '#ddd',
        muted: '#eee',
        success: '#87c144',
        info: 'rgb(70, 120, 200)',
        warning: '#daa520',
        online: '#87c144',
        accent: '#5ab9ea',
        accentBackgroundedText: '#fff',
        pageBackground: '#f5f6fb',
        pageText: '#000',
        cardBackground: '#fff',
        cardText: '#000',
        selected: '#5ab9ea',
        charts: {
            primary: '#4abfff',
            min: '#a1e0f8',
            neutral: '#5ab9ea',
            max: '#d92121',
            intervalShade: 'rgba(125,125,125,0.1)',
            grid: 'rgba(125,125,125,0.1)',
            series: ['#5ab9ea', '#254e58', '#5680e9', '#84ceeb', '#c1c8e4', '#8860d0'],
        },
    },
    shadows: [
        'none',
        '0 1px 2px rgba(125,125,125,0.1)',
        '0 2px 4px rgba(125,125,125,0.1)',
        '0 3px 8px rgba(125,125,125,0.1)',
        '0 4px 16px rgba(125,125,125,0.1)',
        '0 5px 32px rgba(125,125,125,0.1)',
    ],
});
//# sourceMappingURL=index.js.map